import { useContext } from 'react'
import DemoContext from 'app/contexts/DemoContext'

const useDemo = () => useContext(DemoContext)

export default useDemo
